import React, { useMemo } from 'react';

import styled from 'styled-components';
import uniqBy from 'lodash/uniqBy';

import { Activity, Media } from '../../../types/Activity';

import ActivityViewActionIcon from './ActivityViewActionIcon';

const StyledWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
`;

const StyledImageWrapper = styled.div`
  position: relative;
  margin-right: 20px;
  margin-bottom: 25px;

  img {
    width: 130px;
  }

  &:first-child {
    img {
      width: 270px;
    }
  }
`;

const StyledActions = styled.div`
  position: absolute;
  right: 10px;
  top: 0;
`;

type Props = {
  activity: Partial<Activity>;
  name: string;
  onEditField?(key: string): void;
};

const ActivityViewMedia = ({ activity, name, onEditField }: Props) => {
  const mediaItems = useMemo(() => uniqBy(activity[name], 'url') || [], [
    activity,
    name,
  ]);

  const renderMedia = (mediaItem: Media) => {
    const url = new URL(
      mediaItem.type === 'image' ? mediaItem.url : mediaItem.thumbnailUrl
    );

    if (url.toString().startsWith('https://ik.imagekit.io')) {
      url.searchParams.set('tr', 'w-1200');
    }

    return (
      <StyledImageWrapper key={mediaItem.id}>
        <img id={mediaItem.id} src={url.toString()} alt='img' />
        {mediaItem.type === 'video' && <PlayIcon />}
      </StyledImageWrapper>
    );
  };

  return (
    <StyledWrapper>
      {mediaItems.map(renderMedia)}
      <StyledActions>
        <ActivityViewActionIcon
          action='edit'
          onClick={() => {
            if (onEditField) {
              onEditField(name);
            }
          }}
        />
      </StyledActions>
    </StyledWrapper>
  );
};

const StyledIconWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.5);
  padding: 2px;
  color: white;
  width: 40px;
  height: 40px;

  display: flex;
  align-items: center;
  justify-content: center;
`;

function PlayIcon() {
  return (
    <StyledIconWrapper>
      <i className='fa fa-play' />
    </StyledIconWrapper>
  );
}

export default React.memo(ActivityViewMedia);
